export const extarctOnlyDay = (timestamp) => {
  const dateObject = new Date(timestamp);
  return dateObject.toLocaleDateString("en-US", { weekday: "long" });
};
//output be Like Monday
